import getPlaybackState from "selectors/chapter/getPlaybackState";

import getChapterDuration from "./getChapterDuration";

export default function getDuration(state, ownProps) {
  const stateKey = ownProps.chapterId
    ? `chapter-${ownProps.chapterId}`
    : "story";
  const playbackState = getPlaybackState(state, { stateKey });
  if (!playbackState) return 0;
  return playbackState.duration || getChapterDuration(state, ownProps);
}
